import styled from 'styled-components';
import { Outlet } from 'react-router-dom';

import Header from './Header/Header';
import SideBar from './SideBar/SideBar';

const Wrapper = styled.div`
  display: flex;
`;

const Main = styled.main`
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: ${(props) => props.theme.home.bgColor};
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const MainLayout = () => {
  return (
    <Wrapper>
      <SideBar />
      <Main>
        <Header />
        <Content>
          <Outlet />
        </Content>
      </Main>
    </Wrapper>
  );
};

export default MainLayout;
